module.exports = __webpack_public_path__ + "img/texas_dark_grey.8868069d.jpg";